module.exports = __webpack_public_path__ + "static/media/logo2.29b2d16e.png";